import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import VehicleInformationUpload from "pages/vehicle-information-upload";
import OfferTrackingDashboard from "pages/offer-tracking-dashboard";
import OfferReviewAcceptance from "pages/offer-review-acceptance";
import VehicleInspectionScheduling from "pages/vehicle-inspection-scheduling";
import TransactionHistoryProfile from "pages/transaction-history-profile";
import ISellCarLandingPage from "pages/i-sell-car-landing-page";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your routes here */}
        <Route path="/" element={<ISellCarLandingPage />} />
        <Route path="/i-sell-car-landing-page" element={<ISellCarLandingPage />} />
        <Route path="/vehicle-information-upload" element={<VehicleInformationUpload />} />
        {/* <Route path="/offer-tracking-dashboard" element={<OfferTrackingDashboard />} />
        <Route path="/offer-review-acceptance" element={<OfferReviewAcceptance />} />
        <Route path="/vehicle-inspection-scheduling" element={<VehicleInspectionScheduling />} />
        <Route path="/transaction-history-profile" element={<TransactionHistoryProfile />} /> */}
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;